<template>
  <div class="bg-canicross d-flex align-items-center justify-content-center">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card card-success text-center p-4 p-md-5">

            <div class="icon-circle mx-auto mb-4 shadow-sm">
                <img :src="xhidenxi" alt="XHIDENXI" class="logo-img">
            </div>

            <h1 class="text-xhidenxi h5 mb-2">XHIDENXI</h1>
            <h2 class="fw-extrabold text-dark mb-4">¡REGISTRO ENVIADO!</h2>

            <div class="registration-box mb-4">
              <p class="text-muted small mb-1 text-uppercase fw-bold">Número de Folio Provisional</p>
              <h3 class="display-4 fw-black text-dark">#{{ String(props.numeroCorredor).padStart(3, '0') }}</h3>
              <p class="small text-danger">*Validación de pago pendiente</p>
            </div>

            <hr class="my-4">

            <div class="instructions-section text-start mb-4">
              <div class="d-flex mb-3">
                <div class="step-num me-3">1</div>
                <p class="mb-0">
                  <strong>Confirmación:</strong> Los organizadores revisarán tu comprobante para asignarte tu número de
                  corredor oficial. Nos pondremos en contacto contigo a la brevedad para confirmar la recepción y
                  asegurar tu lugar en la línea de salida. <br> <strong>🐾 NOTA - Tu registro quedará pendiente si
                    el pago no coincide con los datos proporcionados o fue realizado de forma incorrecta.</strong>
                </p>
              </div>

              <div class="d-flex mb-3">
                <div class="step-num me-3">2</div>
                <p class="mb-0">
                  <strong>Tu Foto de Corredor:</strong> Una vez que confirmemos tu registro con tu número oficial de
                  corredor, envíanos una foto tuya realizando actividad física o corriendo al WhatsApp:
                  <a href="https://wa.me/525540861907" target="_blank" class="text-dark fw-bold text-decoration-none">
                    <br>📞 5540861907
                  </a>
                </p>
              </div>
            </div>

            <div class="d-grid mt-5">
              <button @click="irAHome" class="btn btn-canicross btn-lg py-3">
                TERMINAR Y REGRESAR
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue'
import { useRouter } from 'vue-router'
import xhidenxi from '@/assets/images/patrocinadores/logoXhiBlanco.png'

const props = defineProps(['numeroCorredor'])

const router = useRouter()
const registroFolio = ref('')

// Simulamos la generación de un folio aleatorio al cargar
onMounted(() => {
  registroFolio.value = Math.floor(1000 + Math.random() * 9000)
})

const irAHome = () => {
  router.push('/')
}
</script>

<style scoped>
/* Estilos alineados al Banner */
.bg-canicross {
  background: linear-gradient(180deg, #e1f5d4 0%, #ffffff 100%);
  min-height: 100vh;
}

.card-success {
  border: none;
  border-radius: 24px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  background: white;
}

.text-xhidenxi {
  letter-spacing: 4px;
  font-weight: 900;
  color: #333;
}

.registration-box {
  background: #f8fdf5;
  border: 2px dashed #000;
  border-radius: 15px;
  padding: 20px;
}

.fw-black { font-weight: 900; }

.icon-circle {
  width: 100px;
  height: 100px;
  background-color: #000;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 3px solid #fff;
  transition: transform 0.3s ease;
}

.icon-circle:hover {
  transform: scale(1.05);
}

.logo-img {
  width: 70%;
  height: 70%;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.step-num {
  background: #000;
  color: #fff;
  width: 28px;
  height: 28px;
  min-width: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 0.8rem;
}

.btn-canicross {
  background: #000;
  color: #fff;
  border-radius: 12px;
  border: none;
  transition: all 0.3s ease;
}

.btn-canicross:hover {
  background: #222;
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}
</style>
